import React, {
  useCallback 
} from "react";

import {
  useStyle 
} from "../../classify";
import defaultClasses from "./tile.module.css";

const Tile = props => {
  const {
    isActive, number, onClick, onSetPage 
  } = props;

  const classes = useStyle(defaultClasses, props.classes);
  const rootClass = isActive ? classes.root_active : classes.root;
  const handleClick = useCallback(() => {
    onClick(number), onSetPage && onSetPage();
  }, [onClick, number]);

  return (
    <button
      className={rootClass}
      onClick={handleClick}
      data-cy={isActive ? "Tile-activeRoot" : "Tile-root"}
    >
      {number}
    </button>
  );
};

export default Tile;
